import React, { useState, useEffect } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const Dropdown = ({ propertyType, status, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Check if URL matches broker or builder paths
  const isSpecialPath =
    location.pathname.includes("residential-rental/broker") ||
    location.pathname.includes("residential-rental/builder");
  const isRequirementPath = location.pathname.includes("residential-rental/requirement");

  // Define options based on URL path
  const getOptions = () => {
    if (isRequirementPath) {
      return ["Active", "Fulfilled", "Cancelled"];
    }
    if (isSpecialPath) {
      return ["Available", "Rented", "Sold", "Fake Listing"];
    }

    return propertyType === "Residential Sell" || propertyType === "Commercial Sell"
      ? [
        "Active",
        "Not Answer",
        "Sell out",
        "Data Mismatch",
        "Broker",
        "Duplicate",
      ] 
      : [
        "Active",
        "Not Answer",
        "Rent out",
        "Data Mismatch",
        "Broker",
        "Duplicate",
      ];
  };

  const options = getOptions();

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const getStatusClassName = (status) => {
    const s = status?.toLowerCase();
    
    // Special Path logic
    if (isSpecialPath) {
      switch (s) {
        case "available":
          return "bg-gradient-to-r from-green-500/10 to-emerald-500/10 text-green-700 border-green-200";
        case "rented":
          return "bg-blue-500 text-white";
        case "sold":
          return "bg-red-500 text-white";
        case "fake listing":
          return "bg-gray-700 text-white";
        default:
          return "bg-gray-500 text-white";
      }
    } else if (isRequirementPath) {
      switch (s) {
        case "active":
          return "bg-gradient-to-r from-green-500/10 to-emerald-500/10 text-green-700 border-green-200";
        case "fulfilled":
          return "bg-blue-500 text-white";
        case "cancelled":
          return "bg-red-500 text-white";
        default:
          return "bg-gray-500 text-white";
      }
    }

    // Default color mappings
    switch (status) {
      case "Active":
        return "bg-gradient-to-r from-green-500/10 to-emerald-500/10 text-green-700 border-green-200";
      case "Rent out":
      case "Sell out":
        return "bg-red-500 text-white";
      case "Data Mismatch":
        return "bg-gray-500 text-white";
      case "Not Answer":
        return "bg-yellow-500 text-white";
      case "Broker":
        return "bg-blue-500 text-white";
      case "Duplicate":
        return "bg-purple-500 text-white";
      default:
        return "bg-gray-500 text-white";
    }
  };

  return (
    <div className={`relative inline-block text-left ${isOpen ? "z-[100]" : "z-10"}`}>
      <button
        type="button"
        className={`border border-gray-300 rounded-lg px-2 w-full h-8 lg:h-10 py-1 lg:py-2 flex items-center justify-between gap-2 shadow-sm transition-all duration-200 ${getStatusClassName(status)}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="truncate">{status}</span>
        {isOpen ? (
          <FaChevronUp size={12} className="flex-shrink-0" />
        ) : (
          <FaChevronDown size={12} className="flex-shrink-0" />
        )}
      </button>

      {isOpen && (
        <ul className="absolute left-0 mt-2 min-w-[160px] bg-white border border-gray-200 rounded-xl shadow-2xl z-[1000] py-2 animate-in fade-in zoom-in duration-200 origin-top-left">
          {options.map((option) => (
            <li
              key={option}
              className={`px-4 py-2.5 cursor-pointer hover:bg-purple-50 hover:text-[#503691] text-sm font-medium transition-colors whitespace-nowrap ${status === option ? "bg-purple-50 text-[#503691]" : "text-gray-700"}`}
              onClick={() => handleOptionClick(option)}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
